// extracted by mini-css-extract-plugin
export default {"logoContainer":"Logo_logoContainer__LpyFR","clientDetailsRow":"Logo_clientDetailsRow__2GeDX","placeRow":"Logo_placeRow__T0b8d","img":"Logo_img__AImsF"};